<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="from_div">
			<div class="receipt_div">
				<el-form ref="form" :model="form" class="title_div">
					<span class="title" v-if="type != -1">NO:{{form.bill_no}}</span>
					<el-form-item style="margin-bottom: 10px;">
						<el-radio-group v-model="form.bill_type" class="item" @input="groupInput">
							<el-radio :label="1">收款单</el-radio>
							<el-radio :label="2">付款单</el-radio>
						</el-radio-group>
						<el-divider class="lin" />
					</el-form-item>
					<el-form-item style="margin-left: 40px;">
						<el-date-picker class="picker" :clearable='false' align="center" v-model="form.bill_time"
							type="datetime" placeholder="请选择时间" value-format="yyyy-MM-dd HH:mm:ss" />
					</el-form-item>
					<el-form-item style="margin-left: 40px;">
						<span>单位</span>
						<el-input class="input" v-model="form.bill_object" placeholder="对方名称" />
						<span>方式</span>
						<el-select class="select" v-model="form.bill_paytype" clearable placeholder="请选择">
							<el-option v-for="item in payTypeList" :key="item.code" :label="item.message"
								:value="item.code" />
						</el-select>
					</el-form-item>
					<el-form-item>
						<span>金额（小写）</span>
						<el-input class="input" v-model="form.bill_amount" placeholder="请输入金额"
							@input="limitInput($event,'bill_amount')" />
						<span>（人民币大写：{{transform(form.bill_amount)}}）</span>
					</el-form-item>
					<el-form-item>
						<span>事由</span>
						<el-input class="input" style="width: 580px;" v-model="form.remark" placeholder="请输入内容" />
					</el-form-item>
					<el-form-item>
						<div class="row">
							<div class="col">
								<span>类目：</span>
								<div class="row">
									<el-select class="select" v-model="form.cate_id1" clearable placeholder="一级类目"
										@change="cateChange">
										<el-option :disabled="item.children.length == 0" v-for="item in cate1List"
											:key="item.cate_id" :label="item.cate_name" :value="item.cate_id" />
									</el-select>
									<el-select v-if="form.cate_id1 != ''" class="select" v-model="form.cate_id2"
										clearable placeholder="二级类目">
										<el-option v-for="item in cate2List" :key="item.cate_id" :label="item.cate_name"
											:value="item.cate_id" />
									</el-select>
								</div>
							</div>
							<div class="col">
								<span>关联客户：</span>
								<div class="row">
									<el-select class="select" style="width: 170px;" v-model="form.consumer_id" clearable
										placeholder="客户列表" @change="consumerChange">
										<el-option v-for="item in consumerList" :key="item.consumer_id"
											:label="item.consumer_name" :value="item.consumer_id" />
									</el-select>
								</div>
							</div>
							<div class="col">
								<span>关联合同：</span>
								<div class="row">
									<el-select class="select" style="width: 170px;" v-model="form.contract_id" clearable
										placeholder="合同列表">
										<el-option v-for="item in contractList" :key="item.procurement_id"
											:label="item.procurement_name" :value="item.procurement_id" />
									</el-select>
								</div>
							</div>
						</div>
					</el-form-item>
					<el-form-item v-if="type != -1" style="margin-bottom: 0px;">
						<span>制单人：{{form.createdInfo}}</span>
						<!-- <span style="margin-left: 200px;">审批：</span> -->
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm()">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import {
		numToRMB
	} from "../../../../src/common/store/util.js"
	import {
		bill,
		billCate,
		consumerLists,
		procurementLists
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
		props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				tip: '添加新的收款单或付款单。',
				payTypeList: [], //支付方式列表
				cate1List: [], //一级分类列表
				cate2List: [], //二级分类类别
				consumerList: [], //客户列表
				contractList: [], //合同列表
				form: {
					bill_type: 1, //类型:1=收款单,2=付款单
					bill_time: '', //时间
					bill_object: '', //单位,对方名称
					bill_paytype: '', //支付方式:1=银行转账,2=现金,3=微信,4=支付宝,5=其他
					bill_amount: '', //金额
					remark: '', //事由
					cate_id1: '', //分类1
					cate_id2: '', //分类2
					consumer_id: '', //客户id
					contract_id: '' //合同id
				}
			}
		},
		mounted() {
			this.getCatelist();
			this.getBillOptions();
			this.getConsumerList();
		},
		methods: {

			//获取收付款单详情
			getBillDetail() {
				bill({
					bill_id: this.form.bill_id
				}, 3).then(res => {
					if (res.code == 0) {
						for (var key in res.data) {
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
						this.cateChange(res.data.cate_id1);
						this.consumerChange(res.data.consumer_id);
						this.form.bill_no = res.data.bill_no
						this.form.createdInfo = res.data.created_role + ' - ' + res.data.created_admin.nick_name
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

			limitInput(value, name) {
				this.form[name] =
					("" + value) // 第一步：转成字符串
					.replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
					.replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
					.replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
					.match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
			},

			//group切换
			groupInput(val) {
				this.form.cate_id1 = '';
				this.form.cate_id2 = '';
				this.form.bill_type = val;
				this.getCatelist();
			},

			//获取收付款选项数据
			getBillOptions() {
				bill({}, 5).then(res => {
					if (res.code == 0) {
						this.payTypeList = res.data.bill_paytypes
						if (this.type != -1) {
							//详情编辑
							this.form.bill_id = this.type;
							this.getBillDetail();
						}
					}
				})
			},

			//获取分类列表
			getCatelist() {
				billCate({
					cate_type: this.form.bill_type
				}, 4).then(res => {
					if (res.code == 0) {
						this.cate1List = res.data
					}
				}).catch(err => {})
			},

			//获取客户列表
			getConsumerList() {
				consumerLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code == 0) {
						this.consumerList = res.data
					}
				}).catch(err => {})
			},

			//一级类目筛选
			cateChange(cart_id) {
				if (cart_id != '') {
					var key = this.cate1List.findIndex(item => item.cate_id == cart_id);
					if (this.cate1List[key].children.length > 0) {
						this.cate2List = this.cate1List[key].children;
					}
				}
			},

			//客户列表筛选
			consumerChange(consumer_id) {
				//获取合同列表
				procurementLists({
					consumer_id: consumer_id
				}, 3).then(res => {
					this.contractList = res.data
				})
			},

			//rmb转换
			transform(rmb) {
				return numToRMB(rmb);
			},

			//表单提交
			submitForm() {
				var type = this.type != -1 ? 2 : 0;
				bill({
					...this.form
				}, type).then(res => {
					if (res.code == 0) {
						this.$emit('close', 0)
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.title {
		font-size: 16px;
		text-shadow: 0 1px 0 #fff, 0 2px 0 #888,
			0 3px 0 #555, 0 4px 0 #666,
			0 5px 0 #333, 0 6px 2px rgba(0, 0, 0, .2),
			0 6px 1px rgba(0, 0, 0, .1), 0 0 5px rgba(0, 0, 0, .1),
			0 1px 3px rgba(0, 0, 0, .3), 0 3px 5px rgba(0, 0, 0, .2),
			0 5px 10px rgba(0, 0, 0, .25), 0 10px 10px rgba(0, 0, 0, .2),
			0 20px 20px rgba(0, 0, 0, .15);
	}

	.from_div {
		display: flex;
		justify-content: center;
		width: 100%;
		margin: 40px 20px 20px 20px;
	}

	.receipt_div {
		width: 50%;
		padding: 40px 30px;
		border: 1px solid #767676;
		border-radius: 10px;
	}

	.title_div {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.lin {
		display: block;
		height: 1px;
		width: auto;
		margin: 20px 120px;
	}

	.item {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}

	.input {
		width: 200px;
		margin: 0 20px;
	}

	.select {
		width: 100px;
		margin: 0 20px;
	}

	/deep/.el-input__inner {
		border-left: none;
		border-right: none;
		border-top: none;
		border-radius: 0;
	}

	/deep/.el-radio__label {
		font-size: 17px;
	}

	/* /deep/.el-radio__inner{
		width: 17px;
		height: 17px;
	} */

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}
</style>